import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PayeeButtonComponent } from 'src/app/shared/payee-buttons/payee-button/payee-button.component';
import { ChipDropdownComponent } from 'src/app/shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from 'src/app/shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from 'src/app/shared/payee-input/payee-input.directive';
import { EventsService } from '../events.service';

@Component({
  selector: 'app-events-label-filter',
  templateUrl: './events-label-filter.component.html',
  imports: [
    FormsModule,
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    ReactiveFormsModule,
    PayeeButtonComponent,
    PayeeInputDirective,
    TranslateModule,
  ],
})
export class EventsLabelFilterComponent implements OnInit, OnDestroy {
  private eventsService = inject(EventsService);

  private readonly destroy = new Subject<void>();
  readonly labelControl = new FormControl<string | null>('', [
    Validators.required,
    Validators.minLength(2),
  ]);

  dropdownOpen = false;

  get selected() {
    return this.eventsService.label.value;
  }

  ngOnInit(): void {
    this.eventsService.label
      .pipe(takeUntil(this.destroy))
      .subscribe((v) => this.labelControl.patchValue(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  applyFilter(): void {
    if (this.labelControl.invalid) {
      this.labelControl.markAsDirty();
      return;
    }

    this.eventsService.label.next(this.labelControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.eventsService.label.next(null);
    this.dropdownOpen = false;
  }

  displayWith(selected: string): string {
    return selected;
  }

  onPaste(_event: ClipboardEvent): void {
    this.labelControl.markAsTouched();
    setTimeout(() => {
      this.applyFilter();
    });
  }
}
